export default __webpack_public_path__ + "static/media/delete_greyBlue.50c28df7.svg";